import { motion } from 'framer-motion'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Meal } from '@widgets/meal'

import { Btn } from '@shared/ui/btn'

// import { useTgData } from '@shared/lib/useTgData'

const MealPage = () => {
  const { t } = useTranslation()

  const { mealId } = useParams()

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="mt-3">
        <Btn design={['text-link']} link="/">
          <i className="fa-solid fa-arrow-left me-2" />
          {t('buttons:goToMain')}
        </Btn>
      </div>

      <Meal id={mealId} />
    </motion.div>
  )
}

export default memo(MealPage)
